<template>
  <div class="card-pei"
       :key="componentKey"
       :class="{'not-allowed': disabled}"
       @click="clickItem">   
    <div class="card-header"
         :id="headingOne">
      <div class="row">
        <div class="col-12">
          <div class="tag-badge-pei mb-0">
            <div
              :class="{ 'collapsed': !expanded }"
              class="btn collapsed no-border"
              data-toggle="collapse"
              :data-target="`#${collapseOne}`"
              :aria-expanded="expanded"
              :aria-controls="collapseOne">
              <span class="dot-pei" :class="{'error': error}">
                <i v-if="checked && !error"
                   class="fas fa-check-circle text-green"></i>
                <i v-if="selected && !checked && !error"
                   class="fas fa-plus orange-icon"></i>
                <i v-if="!checked && !selected && !error"
                   class="fas fa-plus text-gray"></i>
                <i v-if="error"
                   class="fas fa-plus icon-error"></i>
              </span>
              <span class="title-pei">{{ title }}</span>
            </div>
          </div>
          <span v-if="!error"
                class="text-alert text-gray">{{ alert }}</span>
          <span v-if="error"
                class="text-alert text-error">{{ customErrorMsg }}</span>
        
          <div class="add-button float-right">
            <action-button v-if="buttonText"
                          class="myi-0" 
                          :i="buttonIcon" 
                          :variant="buttonClass" 
                          :type="buttonType" 
                          :disabled="disabled"
                          @click="onButtonClick">
              {{ buttonText }}
            </action-button>
          </div>
          <div v-show="$slots['extraHeaderContent']" class="pt-2 float-right">
            <slot name="extraHeaderContent"/>
          </div>
        </div>       
      </div>
    </div>

    <div
      :id="collapseOne"   
      :class="{ collapse: true, show: computedExpanded }"
      :aria-labelledby="headingOne"
      :data-parent="`#${parentId}`">
      <div class="card-body shadow2" :style="{'background-color': bodyBackgroundColor}">
        <slot />
        <div class="actions">
          <slot name="actions"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from "@/components/common/ActionButton";
export default {
  name: "CustomCollapseItem",
  meta: {
    description: 'CustomCollapseItem, hijo del CustomCollapse',
    slots: {
      default: {
        type: 'component',
        valid: [],
      }
    },
  },
  components: {
    ActionButton
  },
  props: {
    componentKey: {
      type: Number,
      required: false,
      default: 0,
      meta: {
        description: 'Id contenedor',
        example: '14',
      }
    },
    parentId: {
      type: String,
      required: true,
      default: 'idCustomCollapse',
      meta: {
        description: 'Id del Componente padre',
        example: 'idCustomCollapse',
      }
    },
    title: {
      type: String,
      required: true,
      default: "Header",
      meta: {
        description: 'Título del header',
        example: 'Texto Necesario',
      }
    },
    alert: {
      type: String,
      required: false,
      default: "",
      meta: {
        description: 'Mensaje después del header para notificaciones',
        example: 'Texto Necesario',
      }
    },
    checked: {
      type: Boolean,
      required: false,
      default: false,
      meta: {
        description: 'Cambia al estado checked',
        example: 'true',
      }
    },
    selected: {
      type: Boolean,
      required: false,
      default: false,
      meta: {
        description: 'Cambia al estado selected',
        example: 'true',
      }
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
      meta: {
        description: 'Estado que expande el contenedor',
        example: 'true',
      }
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
      meta: {
        description: 'Estado Disabled',
        example: 'true',
      }
    },
    error: {
      type: Boolean,
      required: false,
      default: false,
      meta: {
        description: 'Estado Error',
        example: 'true',
      }
    },
    buttonIcon: {
      type: String,
      required: false,
      default: "fas fa-file-plus",
      meta: {
        description: 'Icono del botón',
        example: 'Texto Necesario',
      }
    },
    buttonClass: {
      type: String,
      required: false,
      default: "success m-2",
      meta: {
        description: 'Clases para el botón  ',
        example: 'Texto Necesario',
      }
    },
    buttonType: {
      type: String,
      required: false,
      default: "",
      meta: {
        description: 'Tipo del botón',
        example: 'Texto Necesario',
      }
    },
    buttonText: {
      type: String,
      required: false,
      default: "",
      meta: {
        description: 'Texto del boton',
        example: 'Texto Necesario',
      }
    },
    customErrorMsg: {
      type: String,
      required: false,
      default: "Este campo debe ser completado.",
      meta: {
        description: 'Detalles del Error',
        example: 'Texto Necesario',
        }
      },
      bodyBackgroundColor: {
      type: String,
      default: "",
      meta: {
        description: 'Establece un Color de fondo del body',
        example: 'Texto Necesario',
        }
    }
  },
  data: () => ({
    headingOne: null,
    collapseOne: null
  }),
  computed: {
    computedExpanded() {
      return !this.disabled && this.expanded;
    }
  },
  watch: {
    expanded(newV, oldV) {
      if (newV && newV != oldV) {
        this.collapseAllAndExpandCurrent();
      }
    }
  },
  mounted() {
    this.headingOne = `heading_${this._uid}`;
    this.collapseOne = `collapse_${this._uid}`;
  },
  methods: {
    collapseItem() {
      let element = document.querySelector('[id*="' + this.collapseOne + '"]');
      if (element.classList.contains("show")) {
        element.classList.remove("show");
      }
    },
    expandItem() {
      let element = document.querySelector('[id*="' + this.collapseOne + '"]');
      if (!element.classList.contains("show")) {
        element.classList.add("show");
      }
    },
    clickItem: function(evt) {
      if (this.disabled) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }
    },
    onButtonClick() {
      this.collapseAllAndExpandCurrent();
      this.$emit("collapseItemButtonClick");
    },
    collapseAllAndExpandCurrent() {
      let elements = document.querySelectorAll('[id*="collapse_"]');
      for (let i = 0; i < elements.length; i++) {
        if (elements[i].id != this.collapseOne) {
          if (elements[i].classList.contains("show"))
            elements[i].classList.remove("show");
        } else {
          if (!elements[i].classList.contains("show")) {
            elements[i].classList.add("show");
          }
        }
      }
    }
  }
}

</script>

<style scoped>
.card-pei {
  margin-left: -1.2%;
  width: 102.4%;
  background-color: #ffffff;
}
.tag-badge-pei {
  display: inline-flex;
  padding-right: 1em;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  cursor: pointer;
}
.dot-pei {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
  display: inline-block;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  text-align: center;
}
.dot-pei .fas {
  font-size: 17px;
}
.dot-pei .fas.fa-check-circle {
  font-size: 24px;
}
.dot-pei.error {
  background-color: #ff5b5c;
}
.dot-pei.error i.icon-error {
  color: white;
}
.title-pei {
  font-weight: 700;
  margin-left: 0.5rem;
}
.fa-xl {
  font-size: 1.5em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}
.shadow2 {
  box-shadow: 0px 8px 10px #e4e6e2 inset;
}
.card-body.shadow2 {
}
.no-border {
  border: none !important;
}
.orange-icon {
  color: #ff7058;
}
.text-alert {
  margin-left: 1rem;
  font: 400 16px/19px Lato;
  letter-spacing: 0;
}
.actions {
  display: flex;
  justify-content: flex-end;
}
.not-allowed,
.not-allowed .tag-badge-pei,
.not-allowed .tag-badge-pei .btn {
  cursor: not-allowed;
}
.fa-edit:before {
  font-size: 18px !important;
}

.icon-red {
  margin-top: 10px !important;
  font-size: 18px !important;
}

.float-right {
  float: right;
}
.add-button button {
  margin: 0 !important;
}
.card-header {
  border-bottom: none;
}
</style>
